import { render, staticRenderFns } from "./DeminimisThreshold.vue?vue&type=template&id=013db9a4&scoped=true"
import script from "./DeminimisThreshold.vue?vue&type=script&lang=js"
export * from "./DeminimisThreshold.vue?vue&type=script&lang=js"
import style0 from "./DeminimisThreshold.vue?vue&type=style&index=0&id=013db9a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013db9a4",
  null
  
)

export default component.exports